import React, {useContext} from "react";
import {useForm, FormProvider} from "react-hook-form";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as MyProfileFragment from './MyProfileFragmentComponent';
import * as CustomStyles from '../styles/CustomStyles';
import {TabPanel, a11yProps} from "../custom/CustomTabPanelComponent";
import BucketContext from "../context/BucketContext";
import AuthContext from "../context/AuthContext";
import * as PswdManager from '../../utils/auth/AuthCognito';


const TabBottomButtonBar = (props) => {
    return (
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            <Grid item xs={6} container justifyContent="flex-start" alignItems="flex-start">
            </Grid>
            <Grid item xs={6} container justifyContent="flex-end" alignItems="flex-end">
                <Button variant="outlined" type="submit" sx={{ marginRight: 1 }}> {props.buttonLabel} </Button>
            </Grid>
        </Grid>
    );
}

function MyProfileTabRenderer(props) {
    console.log('MyProfile tab renderer');

    const bucketContext = useContext(BucketContext);
    const authContext = useContext(AuthContext);

    const methods = useForm({
        defaultValues: {
            lUser: authContext.afUser,
            lClient: props.client
        }
    });
    const handleSubmit = methods.handleSubmit;

    const myprofileTabIndex = bucketContext.bucket.myprofileTabIndex != null ? bucketContext.bucket.myprofileTabIndex : 0;

    const [tabIndex, setTabIndex] = React.useState(myprofileTabIndex);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        bucketContext.setBucketValue({ myprofileTabIndex: newValue });
    };


    const handleSubmitPersonalDataChange = (data) => {

        methods.reset();
    }


    const handleSubmitPswdChange = (data) => {
        console.log(authContext.username + " - " + data.lUser.passwordSection.oldPassword + " - " + data.lUser.passwordSection.newPassword);

        PswdManager.changePassword(data.lUser.passwordSection.oldPassword, data.lUser.passwordSection.newPassword)
            .then(response => {
                console.log("> Pswd Change response: " + JSON.stringify(response));
                bucketContext.setBucketValue({
                    snackbar: { open: true, severity: "success", message: "Parola a fost schimbate cu succes" }
                });
            })
            .catch(error => {
                console.log("> Pswd Change error: " + error);
                bucketContext.setBucketValue({snackbar: { open: true, severity: "error", message: "Eroare in timpul schimarii parolei - " + error.code } });
            });
        methods.reset();
    }

    return(
        <React.Fragment>

            <FormProvider {...methods} >
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="scrollable tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Date Personale" {...a11yProps(0)} />
                            <Tab label="Parola" {...a11yProps(1)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={tabIndex} index={0}>
                        <form onSubmit={handleSubmit(handleSubmitPersonalDataChange)} id={'personalDataTabForm'}>
                            <MyProfileFragment.RenderPersonalDataSection />
                            <TabBottomButtonBar
                                buttonLabel='Salveaza Date Personale'
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <form onSubmit={handleSubmit(handleSubmitPswdChange)} id={'passwordDataTabForm'}>
                            <MyProfileFragment.RenderPasswordSection />
                            <TabBottomButtonBar
                                buttonLabel='Salveaza Parola'
                            />
                        </form>
                    </TabPanel>

                </Box>
            </FormProvider>
        </React.Fragment>
    );
}

export default MyProfileTabRenderer;